<template>
  <!-- system 标准列表：对齐 police-record/index.vue -->
  <div>
    <avue-crud ref="crud" v-model="form" :option="option" :table-loading="loading" :data="data" :page.sync="page" :search.sync="query" :defaults.sync="defaults" @search-change="searchChange" @search-reset="searchReset"
      @refresh-change="refreshChange" @current-change="currentChange" @size-change="sizeChange" @on-load="onLoad" @row-save="rowSave" @row-update="rowUpdate" @row-del="rowDel" @before-open="beforeOpen">
      <template slot="menuLeft">
        <el-button type="primary" size="small" icon="el-icon-data-line" @click="openPlcSimulator">
          PLC数据模拟
        </el-button>
      </template>
      <template slot="_norma" slot-scope="{ row }">
        <div> {{ row.normalMin }} - {{ row.normalMax }}</div>
      </template>
    </avue-crud>

    <SelectDeviceList ref="selectDeviceList" @replace="replace" />

    <plc-simulator-dialog :visible.sync="plcSimulatorVisible" @refresh="onLoad(page)" />
  </div>
</template>

<script>
import crudMixins from "@/mixins/crud-mixins";
import { getList, add, update, remove, getDetail } from "./api";
import { searchTimeConfig } from "@/basic-common/util/common";
import { getMonthStartTime, getTodayEndTime } from "@/util/date.js";
import SelectDeviceList from "./components/select-device-list";
import PlcSimulatorDialog from "./components/plc-simulator-dialog";
export default {
  name: "system-alarm-settings",
  mixins: [crudMixins],
  components: { SelectDeviceList, PlcSimulatorDialog },
  data () {
    return {
      apiConfig: { getList, add, update, remove, getDetail },
      plcSimulatorVisible: false,
      option: {
        ...this.$store.state.publicOption,
        searchDateProp: false,
        menu: true,
        addBtn: true,
        // delBtn: false,
        editBtn: true,
        viewBtn: true,
        dialogWidth: "1200px",
        dialogHeight: "900px",
        column: [
          {
            label: "设备名称",
            prop: "deviceName",
            // width: 150,
            overHidden: true,
            search: true,
            rules: [
              { required: true, message: "请输入", trigger: "change" },
            ],
            readonly: true,
            click: () => {
              const { dialogForm } = this.$refs.crud.$refs
              if (dialogForm.boxVisible) {
                this.$refs.selectDeviceList.open()
              }
            },
          },
          {
            label: '设备分类',
            prop: 'category',
            search: true,
            type: "select",
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=category",
            dicFormatter: true,
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            dataType: "string",
            rules: [
              { required: true, message: "请选择设备类型", trigger: "change" },
            ],
          },
          {
            label: "类型",
            prop: "deviceType",
            type: "select",
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=device_alarm_type",
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            dataType: "string",
            rules: [
              { required: true, message: "请选择设备类型", trigger: "change" },
            ],
          },
          {
            label: "处理机制",
            prop: "handlingMechanism",
            align: "center",
            type: "select",
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=handling_mechanism",
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            dataType: "string",
          },
          {
            label: "参数名称",
            prop: "parameterName",
            align: "center",
            maxlength: 100,
            rules: [
              { required: true, message: "请输入参数名称", trigger: "change" },
            ],
          },
          {
            label: "参数key",
            prop: "parameterKey",
            align: "center",
            maxlength: 100,
            rules: [
              { required: true, message: "请输入参数key", trigger: "change" },
            ],
          },
          // {
          //   label: "参数值",
          //   prop: "parameterValue",
          //   align: "center",
          // },
          {
            label: "报警范围区间",
            prop: "_norma",
            align: "center",
            display: false,
          },
          {
            label: '报警左区间值',
            prop: 'normalMin',
            type: 'number',
            precision: 0, // 整数
            step: 1, // 步长为1
            disabled: false, // 设置为只读
            hide: true,
            value: 0, // 默认值0
            rules: [
              {
                validator: (rule, value, callback) => {
                  if (!value && !this.form.normalMax) {
                    callback(new Error('报警左区间值和右区间值至少填写一个'));
                  } else {
                    callback();
                  }
                },
                trigger: ['change', 'blur']
              }
            ]
          },
          {
            label: '报警右区间值',
            prop: 'normalMax',
            type: 'number',
            hide: true,
            precision: 0, // 整数
            step: 1, // 步长为1
            disabled: false, // 设置为只读
            value: 0, // 默认值0
            rules: [
              {
                validator: (rule, value, callback) => {
                  if (!value && !this.form.normalMin) {
                    callback(new Error('报警左区间值和右区间值至少填写一个'));
                  } else {
                    callback();
                  }
                },
                trigger: ['change', 'blur']
              }
            ]
          },


          {
            label: "提醒类型",
            prop: "alertType",
            align: "center",
            search: true,
            // width: 120,
            type: "select",
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=alert_type",
            dicFormatter: true,
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            dataType: "string",
            rules: [
              { required: true, message: "请选择", trigger: "change" },
            ],
          },
          {
            label: "创建人",
            prop: "createName",
            align: "center",
            // width: 100,
            addDisplay: false,
            editDisplay: false,
          },
          {
            label: '创建时间',
            prop: 'createTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            addDisplay: false,
            editDisplay: false,
          },
          {
            label: '备注',
            prop: 'remark',
            maxlength: 50,
            type: "textarea",
            span: 24,
            minRows: 3,
          },
          {
            ...searchTimeConfig,
            searchValue: [],
            paramsKey: ["startTime", "endTime"],
          },
        ]
      },
    }
  },
  methods: {
    replace (row) {
      this.$set(this.form, 'baseDeviceId', row.id)
      this.$set(this.form, 'deviceName', row.deviceName)
      this.$set(this.form, 'category', row.category)
    },
    // 打开PLC数据模拟弹窗
    openPlcSimulator () {
      this.plcSimulatorVisible = true;
    }
  }
}
</script>
<style scoped lang="scss">

</style>
